module.exports = __webpack_public_path__ + "92375fb28438a92c8402db0e88de6ce2.jpg";